<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-50"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]"> ข้อมูลทรัพยากร </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div class="flex flex-col gap-[30px] p-[20px] pt-[12px]">
            <div
              class="m-auto w-[160px] min-w-[160px] h-[160px] border-[1px] border-solid border-[#FBEFF8]"
            >
              <img
                v-if="item.image.image_path"
                :src="
                  item.image.image_path || 'https://placehold.co/160x160/png'
                "
                alt=""
              />
              <img
                v-else
                :src="
                  item.image ||
                  item.image.image_path ||
                  'https://placehold.co/160x160/png'
                "
                alt=""
              />
            </div>
            <div class="w-full flex flex-col items-start gap-[16px]">
              <div class="flex flex-col items-start gap-[2px] self-stretch">
                <div class="PC_Body2-R text-[#7C7379]">ชื่อทรัพยากร</div>
                <div class="PC_Body1-R !text-[#1F1D1F]">
                  {{ item.name || "-" }}
                </div>
              </div>

              <div class="w-full flex items-end justify-between flex-wrap">
                <div
                  class="w-1/2 flex flex-col items-start gap-[2px] self-stretch"
                >
                  <div class="PC_Body2-R text-[#7C7379]">จำนวนคงเหลือ</div>
                  <div class="PC_Body1-R !text-[#1F1D1F]">
                    {{ $numberAndComma(item.quantity) || "0" }}
                  </div>
                </div>
                <div
                  class="w-1/2 flex flex-col items-start gap-[2px] self-stretch"
                >
                  <div class="PC_Body2-R text-[#7C7379]">ลักษณนาม</div>
                  <div class="PC_Body1-R !text-[#1F1D1F]">
                    {{ item.unit_name || "-" }}
                  </div>
                </div>
              </div>

              <div class="flex flex-col items-start gap-[2px] self-stretch">
                <div class="PC_Body2-R text-[#7C7379]">หมวดหมู่</div>
                <div class="PC_Body1-R !text-[#1F1D1F]">
                  {{ item.group_name || "-" }}
                </div>
              </div>

              <div class="flex flex-col items-start gap-[2px] self-stretch">
                <div class="PC_Body2-R text-[#7C7379]">ประเภท</div>
                <div class="PC_Body1-R !text-[#1F1D1F]">
                  {{ item.category_name || "-" }}
                </div>
              </div>

              <div class="flex flex-col items-start gap-[2px] self-stretch">
                <div class="PC_Body2-R text-[#7C7379]">รายละเอียด</div>
                <div class="PC_Body1-R !text-[#1F1D1F]">
                  {{ item.detail || "-" }}
                </div>
              </div>

              <div class="flex flex-col items-start gap-[2px] self-stretch">
                <div class="PC_Body2-R text-[#7C7379]">แหล่งที่มา</div>
                <div class="PC_Body1-R !text-[#1F1D1F]">
                  {{ item.source || "-" }}
                </div>
              </div>

              <ButtonComponent
                v-if="inShelter"
                :label="'ลบออกจากศูนย์'"
                :bClass="'btn_shadow--onlyCancel'"
                @clicked="remove"
              />

              <div class="w-full flex items-end justify-between flex-wrap">
                <div
                  v-if="!inShelter"
                  class="flex flex-col items-start gap-[2px] self-stretch"
                >
                  <div class="PC_Body2-R text-[#7C7379]">สถานะ</div>
                  <Switch2 :active="item.status" @toggleSlider="update" />
                </div>

                <div v-if="!inShelter" class="flex items-center gap-[12px]">
                  <ButtonComponent
                    :icon="'TrashcanIcon'"
                    :bClass="'btn_shadow--2 !w-[48px] !h-[48px]'"
                    @clicked="alertDelete"
                  />
                  <ButtonComponent
                    :icon="'EditIcon'"
                    :bClass="'btn_shadow--2 !w-[48px] !h-[48px]'"
                    :iClass="'!w-[24px] !h-[24px]'"
                    @clicked="edit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useProductStore } from "@/pinia/product";

const productStore = useProductStore();
const item = ref({});
const inShelter = ref(true);
const modalIsOpened = ref(false);

const openModal = (data, setInShelter) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  item.value = data;
  console.log("item", item.value);
  if (setInShelter != null) inShelter.value = setInShelter;
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const emit = defineEmits(["open", "status", "delete", "remove"]);

const edit = () => {
  emit("open", item.value);
  closeModal();
};

const alertDelete = async () => {
  await productStore
    .checkDeleteProduct(item.value.id, { check: 1 })
    .then((response) => {
      if (response.status == 200) {
        if (!response.data.data) {
          const message =
            "หากทำการลบข้อมูลแล้ว \n จะไม่สามารถเรียกคืนข้อมูลดังกล่าวได้ \n ต้องการลบข้อมูลนี้หรือไม่";
          emit("status", message, "warning", "ลบ", item.value, "resource");
        } else {
          emit("delete", item.value);
        }
      }
    })
    .catch((error) => {
      if (error) {
        console.log("error", error);
      }
    });
};

const update = async (switchValue) => {
  const body = {
    name: item.value.name,
    status: switchValue ? 1 : 0,
  };
  if (!switchValue) {
    item.value.status = 0;
  }
  await productStore
    .updateProduct(item.value.id, body)
    .then((response) => {
      if (response.status === 200) {
        const message = response.data.message;
        emit("status", message, "success");
      }
    })
    .catch((error) => {
      if (error) {
        const message = error.response.data.message;
        emit("status", message, "error");
        item.value.status = true;
      }
    });
};

const remove = async () => {
  await productStore
    .DeleteShelterProduct(item.value.id, { check: 1 })
    .then((response) => {
      if (response.status === 200) {
        if (!response.data.data) {
          const message =
            "หากข้อมูลทรัพยากร มีคำร้องขออยู่ เมื่อกดลบ \n คำร้องขอจะถูกยุติทันที ข้อมูลที่ถูกลบไป \n จะหายไปจากศูนย์พักพิงนี้ แต่ประวัติการโอนย้าย \n จะยังคงอยู่ ท่านต้องการลบข้อมูลหรือไม่";
          emit(
            "status",
            message,
            "warning",
            "ลบ",
            item.value,
            "resourceInShelter"
          );
        } else {
          emit("remove", item.value);
        }
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        const message = error.response.data.message;
        emit("status", message, "error");
      } else {
        console.log("error", error);
      }
    });
};

defineExpose({ openModal, closeModal });
</script>
    
<style scoped>
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>